import { RowBetween } from 'layout/Components/Row'
import styled from 'styled-components'
import { Icons } from 'svgs'
import colors from 'theme/ui/colors'
import Box from 'UIKit/Box/Box'
import TransText from 'UIKit/Text/TransText'

const TournamentRulesLoader = () => {
  return (
    <StyledTournamentRulesLoader>
      <RowBetween style={{ cursor: 'pointer' }}>
        <TransText fontSize="14px" fontWeight={600}>
          Tournament Rules
        </TransText>
        <Box>
          <Icons.ArrowDownIcon width="30px" height="30px" />
        </Box>
      </RowBetween>
    </StyledTournamentRulesLoader>
  )
}

const StyledTournamentRulesLoader = styled(Box)`
  padding: 20px;
  border-radius: 12px;
  background: ${colors.backgroundAlt5};
`

export default TournamentRulesLoader
